export default __webpack_public_path__ + "static/media/Background_00154.33f2fd21.png";